import { FC } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { Dashboard, Delete, Download, Edit } from '@mui/icons-material';

interface FileRowActionsProps {
  isEditing: boolean;
  isDownloading: boolean;
  isRenamePending: boolean;
  isDeletePending: boolean;
  isViewer: boolean;
  onViewDashboard: () => void;
  onStartRename: () => void;
  onDownload: () => void;
  onOpenDeleteDialog: () => void;
}

const FileRowActions: FC<FileRowActionsProps> = ({
  isEditing,
  isDownloading,
  isRenamePending,
  isDeletePending,
  isViewer,
  onViewDashboard,
  onStartRename,
  onDownload,
  onOpenDeleteDialog,
}) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
    <Button
      size="small"
      variant="contained"
      startIcon={<Dashboard />}
      onClick={onViewDashboard}
      disabled={isEditing}
    >
      分析
    </Button>
    {!isEditing && (
      <Button
        size="small"
        variant="outlined"
        startIcon={<Edit />}
        onClick={onStartRename}
        disabled={isRenamePending || isViewer}
      >
        名前変更
      </Button>
    )}
    <Button
      size="small"
      variant="outlined"
      startIcon={isDownloading ? <CircularProgress size={20} /> : <Download />}
      onClick={onDownload}
      disabled={isDownloading || isEditing}
    >
      {isDownloading ? '処理中...' : 'ダウンロード'}
    </Button>
    <Button
      size="small"
      variant="outlined"
      color="error"
      startIcon={<Delete />}
      onClick={onOpenDeleteDialog}
      disabled={isDeletePending || isEditing || isViewer}
    >
      削除
    </Button>
  </Box>
);

export default FileRowActions;
